export default "__VITE_ASSET___2o8_7rA__"